import businessExampleHover from "../../resources/js/module/business-example";
import sliderActivities from "../../resources/js/module/sliderActivities";

$(document).ready(function () {
  businessExampleHover();
  sliderActivities();
})
